import React, { useEffect } from 'react';

import { isTelemundoVertical } from 'lib/vertical';
import { initUniCheckout, uniCheckoutSrc } from 'lib/uniCheckout';
import { ErrorBoundary } from 'components/ErrorBoundary';

/**
 *
 * @param {string} vertical
 * @returns {*} Error Boundary
 */
const UniversalCheckout = ({ vertical }) => {
  useEffect(() => {
    if (isTelemundoVertical(vertical)) {
      initUniCheckout();
    }
  }, []);

  return (
    <ErrorBoundary>
      {isTelemundoVertical(vertical) ? <script src={uniCheckoutSrc} /> : null}
    </ErrorBoundary>
  );
};

export default UniversalCheckout;
